import { render, staticRenderFns } from "./ProcessingResultCorrections.vue?vue&type=template&id=1df24cd6"
import script from "./ProcessingResultCorrections.vue?vue&type=script&lang=ts"
export * from "./ProcessingResultCorrections.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports